import PlayerEventBookingsReportsContainer from "../../container/admin/player-event-bookings-reports";

const PlayerEventBookingsReportsView = () => {
    return <PlayerEventBookingsReportsContainer />;
};

export default PlayerEventBookingsReportsView;
